import { Project } from '../../../store/Project';
import { mockTagsData } from '../../Compounds/Tagging/mockTagData';

export const mockProjectData: Project[] = [
  {
    id: '1',
    name: 'Project Alpha',
    progress: '50%',
    siteName: 'Site A',
    supplier: {
      id: 'supplier1',
      name: 'Supplier A',
      sfId: 'Supplier1sfId'
    },
    product: {
      id: 'product1',
      name: 'Product A',
      nameAbbreviation: 'ProdA',
      sfId: 'Product1sfId'
    },
    status: 'In Progress',
    nextSteps: 'Next steps for project 1',
    projectStartDate: '2023-01-01',
    serviceCount: 3,
    account: {
      id: 'customer1',
      name: 'Customer A',
      sfId: 'Customer1sfId'
    },
    tags: [...mockTagsData]
  },
  {
    id: '2',
    name: 'Project Beta',
    progress: '50%',
    siteName: 'Site A',
    supplier: {
      id: 'supplier2',
      name: 'Supplier A',
      sfId: 'Supplier2sfId'
    },
    product: {
      id: 'product2',
      name: 'Product A',
      nameAbbreviation: 'ProdA',
      sfId: 'Product2sfId'
    },
    status: 'In Progress',
    nextSteps: 'Next steps for project 2',
    projectStartDate: '2023-02-02',
    serviceCount: 1,
    account: {
      id: 'customer2',
      name: 'Customer A',
      sfId: 'Customer2sfId'
    },
    tags: mockTagsData.slice(0, 2)
  },
  {
    id: '3',
    name: 'Project Gamma',
    progress: '20%',
    siteName: 'Site A',
    supplier: {
      id: 'supplier3',
      name: 'Supplier A',
      sfId: 'Supplier3sfId'
    },
    product: {
      id: 'product3',
      name: 'Product A',
      nameAbbreviation: 'ProdA',
      sfId: 'Product3sfId'
    },
    status: 'On Hold',
    nextSteps: 'Next steps for project 3',
    projectStartDate: '2023-03-03',
    serviceCount: 12,
    account: {
      id: 'customer3',
      name: 'Customer A',
      sfId: 'Customer3sfId'
    },
    tags: mockTagsData.slice(1, 2)
  }
];
